import BaseNotificationController from './baseNotification_controller'
import { notificationText } from '../../notifications/payload'


export default class extends BaseNotificationController {
  static targets = ['container', 'show', 'nomore', 'allread']

  // NOTIFICATION INDEX PAGE
  // Append next page
  showNextPage() {
    if (this.loading) return

    const currentPage = parseInt(this.containerTarget.dataset.currentPage, 10)
    const totalPages  = parseInt(this.containerTarget.dataset.totalPages, 10)
    // The container already displays currentPage, asking for it again duplicated every card
    const nextPage    = currentPage + 1

    if (nextPage > totalPages) return this._disableShowMoreBtn()

    this.loading = true
    this.containerTarget.appendChild(this._showSpinner())
    this._buildGetRequest(`/notifications?page=${nextPage}`)
      .then(response => response.json())
      .then(data => {
        this._deleteSpinner()
        this.loading = false
        data.forEach(notif => {
          this._compareDate(notif['created_at'])
          this._insertNotification(notif)
        })
        this.containerTarget.dataset.currentPage = nextPage
        if (nextPage >= totalPages) this._disableShowMoreBtn()
      })
      .catch(() => {
        this._deleteSpinner()
        this.loading = false
      })
  }

  // Delete a notification
  deleteNotification(event) {
    const card = event.currentTarget.closest('.small_cards__item')
    const wasUnread = card.classList.contains('unread')
    card.style.opacity = '0.5'
    this._buildRequest(`/notifications/${card.dataset.id}`, 'DELETE', {})
      .then(response => {
        if (!response.ok) return card.style.removeProperty('opacity')

        card.remove()
        // The server drops it from unread_notifications_count, the bell has to follow
        if (wasUnread) this._decreaseCounter()
      })
  }

  // Mark all the notifications as read
  readAll(event) {
    this.markAllAsRead(event, this.containerTarget)
      .then(done => { if (done) this.allreadTarget.classList.add('allread') })
  }

  // Private

  // Build the notification to append — has to mirror views/notifications/_notification.html.erb
  _insertNotification(notif) {
    const unread    = notif['read'] ? '' : 'unread'
    const createdAt = new Date(notif['created_at'])
    const hours     = String(createdAt.getHours()).padStart(2, '0')
    const minutes   = String(createdAt.getMinutes()).padStart(2, '0')

    // insertAdjacentHTML instead of `innerHTML +=`, which reparses and
    // recreates every card already in the list
    this.containerTarget.insertAdjacentHTML('beforeend',
                                       `<div class="small_cards__item my_grey ${unread}"
                                          data-date='${notif['created_at']}'
                                          data-id='${notif['id']}'
                                          data-action="mouseover->notifications--index#markAsRead">
                                          <div class="top-card-workorders-index">
                                            <div class="notification-card">
                                              <div class="notification-card__time">${hours}:${minutes}</div>
                                              ${notif['informations']['bullet']}
                                              <div class="notification-card__message">
                                                ${notificationText(notif['informations'])}
                                              </div>
                                            </div>
                                            <div class="notifications-icons">
                                              <span tooltip="${I18n.t('button.delete')}"
                                                data-action="click->notifications--index#deleteNotification">
                                                <i class="fa fa-trash"></i>
                                              </span>
                                            </div>
                                          </div>
                                        </div>`)
  }

  // nsert the date header if different from the previous one
  _compareDate(created_at) {
    // Check if the day of the last notification is different than the day of the current one
    const cards = this.containerTarget.querySelectorAll('.small_cards__item')
    const lastCard = cards[cards.length - 1]
    if (!lastCard) return

    const last_date = new Date(lastCard.dataset.date)
    const current_date = new Date(created_at)
    // If it is, insert a date
    if (current_date.toDateString() != last_date.toDateString()) {
      this._insertDateHeader(current_date)
    }
  }


  // Format date
  _insertDateHeader(date) {
    const locale = this.containerTarget.dataset.locale
    const formattedDate = date.toLocaleString(locale, {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    })
    // Create date header element
    const containerDiv = document.createElement('div')
    containerDiv.classList.add('notification-date-header')

    // Inserting date into container
    const dateTitle = document.createElement('h3')
    dateTitle.innerText = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
    containerDiv.appendChild(dateTitle)

    // Inserting container
    this.containerTarget.appendChild(containerDiv)
  }

  // Disable "show more" button if there's no more pages to show
  _disableShowMoreBtn() {
    this.showTarget.classList.add('disabled')
    this.nomoreTarget.classList.remove('hidden')
  }
}
